import React from "react";
import { useLang } from "@/i18n";
import { useContent } from "@/content";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { Star } from "@/components/Monogram";
import { waHref } from "@/components/Nav";

export default function NightDinner() {
  const { lang, t } = useLang();
  const { content } = useContent();
  const n = content && content.night_focus;
  if (!n) return null;
  const points = n.points[lang] || n.points.it;
  const contacts = (content && content.contacts) || { whatsapp: "393751163111" };

  return (
    <section className="relative overflow-hidden py-24 sm:py-32" data-testid="night-dinner-section">
      <div className="mx-auto max-w-7xl px-6 sm:px-10 lg:px-16">
        <div className="relative grid grid-cols-1 overflow-hidden border hairline bg-[#101014] lg:grid-cols-2">
          <div className="relative min-h-[320px] overflow-hidden lg:min-h-[560px]">
            <img
              src={n.image}
              alt="Interni di Obsidian di sera"
              className="img-spotlight absolute inset-0 h-full w-full object-cover"
              loading="lazy"
              data-testid="night-dinner-image"
            />
            <div
              className="absolute inset-0"
              style={{ background: "linear-gradient(to right, rgba(10,10,12,0.1), rgba(10,10,12,0.55))" }}
            />
          </div>
          <div className="relative flex flex-col justify-center px-6 py-14 sm:px-12 lg:px-16">
            <Reveal>
              <Eyebrow>Night & Dinner</Eyebrow>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display mt-6 text-3xl font-light leading-tight text-[#FAF9F6] sm:text-4xl" data-testid="night-dinner-headline">
                {t(n.headline)}
              </h2>
            </Reveal>
            <Reveal delay={0.14}>
              <p className="mt-6 text-sm font-light leading-relaxed text-[#A1A1AA] sm:text-[15px]">{t(n.text)}</p>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="font-display mt-8 text-xl italic text-[#C5A059] sm:text-2xl" data-testid="night-dinner-signature">
                “{t(n.signature)}”
              </p>
            </Reveal>
            <Reveal delay={0.24}>
              <ul className="mt-8 space-y-3" data-testid="night-dinner-points">
                {points.map((p, i) => (
                  <li key={i} className="flex items-start gap-3 text-[16px] font-light text-[#A1A1AA]">
                    <span className="mt-[3px] shrink-0">
                      <Star size={9} fill="#C5A059" />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                href={waHref(
                  { whatsapp: contacts.whatsapp, whatsapp_msg: { it: "Ciao, vorrei organizzare la mia serata con Night & Dinner.", en: "Hello, I would like to plan my evening with Night & Dinner." } },
                  lang
                )}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-outline mt-10 self-start"
                data-testid="night-dinner-cta"
              >
                {t(n.cta)}
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
